<template>
  <v-row>
    <v-col cols="12" lg="3">
      <v-select v-model="searchField" :placeholder="$t('labels.column')" :items="translatedFields" hide-details />
    </v-col>
    <v-col cols="12" lg="9" v-if="useList">
      <v-select
        v-model="searchValue"
        :placeholder="$t('labels.value')"
        :items="listValues"
        hide-details
        item-text="name"
        item-value="value"
        @change="addSearchTerm"
      />
    </v-col>
    <v-col cols="12" lg="2" v-if="!useList">
      <v-select v-model="operator" :placeholder="$t('labels.operator')" :items="translatedOperators" hide-details />
    </v-col>
    <v-col cols="12" lg="7" v-if="!useList">
      <v-text-field
        v-model="searchValue"
        :placeholder="$t('labels.value')"
        clearable
        hide-details
        :append-icon="$vuetify.icons.values.addCircleInverted"
        @click:append="addSearchTerm"
        v-on:keyup.enter="addSearchTerm"
        :hint="$t('valueHint')"
      />
    </v-col>
  </v-row>
</template>

<script>
import { EQ_OPERATOR, AND_SEPARATOR, LIKE_OPERATOR } from '../axios'
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '@argon/app/store'

export default {
  name: 'AdvancedSearchRow',
  props: {
    context: { type: String, required: true },
    fields: { type: Array, default: () => [{ label: 'display', type: 'text' }] },
    operators: { type: Array, default: () => [EQ_OPERATOR, LIKE_OPERATOR] }
  },
  data: () => ({
    searchField: null,
    operator: null,
    searchValue: null
  }),
  computed: {
    ...mapState(NAMESPACE, ['appliedFilters']),
    filterObject() {
      return this.appliedFilters[this.context]
    },
    filterItems() {
      return this.filterObject ? this.filterObject.items : []
    },
    translatedFields() {
      return this.fields.map((item) => ({ text: this.$t(`labels.${item.label}`), value: item }))
    },
    translatedOperators() {
      return this.operators.map((value) => ({ text: this.$t(`labels.${value}`), value }))
    },
    useList() {
      return !!this.searchField && this.searchField.type === 'list'
    },
    listValues() {
      return !!this.searchField && this.searchField.type === 'list'
        ? this.searchField.values.map((y) => ({
            name: this.$t(this.searchField.prefix ? `${this.searchField.prefix}.${y}` : `labels.${y}`),
            value: y
          }))
        : []
    }
  },
  watch: {
    searchField: function (newVal, oldVal) {
      this.operator = !!newVal && newVal.type === 'list' ? EQ_OPERATOR : null
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['setAppliedFilter']),
    addSearchTerm() {
      let hasValue = this.searchValue && this.operator && this.searchField
      if (hasValue) {
        const items = [
          ...this.filterItems,
          { field: this.searchField.label, operator: this.operator, value: this.searchValue }
        ]
        this.setAppliedFilter({ context: this.context, filterObject: { separator: AND_SEPARATOR, items } })
        this.searchField = null
        this.operator = null
        this.searchValue = null
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "column": "@:labels.column",
    "operator": "@:labels.operator",
    "value": "@:labels.value",
    "valueHint": "Press 'Enter' or the 'plus' sign to add filter"
  },
  "fr": {
    "column": "@:labels.column",
    "operator": "@:labels.operator",
    "value": "@:labels.value",
    "valueHint": "Appuyez sur 'Entrée' ou sur le signe 'plus' pour ajouter un filtre"
  }
}
</i18n>
